/* ============================================================================
   Lab Effects — PDP Reviews

   The cards are server-rendered by sections/le-pdp-reviews.liquid from the
   custom.reviews_archive metafield, so this file never fetches or builds review
   content — it reorders and hides existing nodes. That keeps the review text in
   the HTML for crawlers no matter what happens here.

   The one network call is helpful votes: Judge.me's API returns no vote counts,
   so the sync Worker keeps its own in KV. GET /votes on load, POST /vote on
   click. If the Worker is unreachable the counts stay at zero and the rest of
   the section is unaffected.
============================================================================ */
(function () {
  "use strict";

  var FLAGS = {
    US: '<rect width="20" height="14" fill="#fff"/><rect y="0" width="20" height="1" fill="#b22234"/><rect y="2" width="20" height="1" fill="#b22234"/><rect y="4" width="20" height="1" fill="#b22234"/><rect y="6" width="20" height="1" fill="#b22234"/><rect y="8" width="20" height="1" fill="#b22234"/><rect y="10" width="20" height="1" fill="#b22234"/><rect y="12" width="20" height="1" fill="#b22234"/><rect width="9" height="7" fill="#3c3b6e"/>',
    CA: '<rect width="20" height="14" fill="#fff"/><rect width="5" height="14" fill="#d52b1e"/><rect x="15" width="5" height="14" fill="#d52b1e"/><path d="M10 3.5l.9 1.6 1.7-.5-.8 1.7 1.5 1-1.7.4.1 1.6L10 9.7 8.3 10.9l.1-1.6-1.7-.4 1.5-1-.8-1.7 1.7.5z" fill="#d52b1e"/>',
    GB: '<rect width="20" height="14" fill="#012169"/><path d="M0 0L20 14M20 0L0 14" stroke="#fff" stroke-width="2.6"/><path d="M10 0V14M0 7H20" stroke="#fff" stroke-width="4"/><path d="M10 0V14M0 7H20" stroke="#c8102e" stroke-width="2"/>',
    DE: '<rect width="20" height="14" fill="#ffce00"/><rect width="20" height="9.3" fill="#dd0000"/><rect width="20" height="4.6" fill="#000"/>',
    AU: '<rect width="20" height="14" fill="#00008b"/><path d="M0 0L20 14M20 0L0 14" stroke="#fff" stroke-width="1.4"/><path d="M5 0V14M0 3.5H10" stroke="#fff" stroke-width="2.4"/><path d="M5 0V14M0 3.5H10" stroke="#f00" stroke-width="1.2"/>'
  };
  var COUNTRY_NAME = { US: "United States", CA: "Canada", GB: "United Kingdom", DE: "Germany", AU: "Australia" };

  function el(tag, attrs, kids) {
    var n = document.createElement(tag);
    if (attrs) for (var k in attrs) {
      if (k === "class") n.className = attrs[k];
      else if (k === "html") n.innerHTML = attrs[k];
      else if (k === "text") n.textContent = attrs[k];
      else if (k.slice(0, 2) === "on") n.addEventListener(k.slice(2).toLowerCase(), attrs[k]);
      else if (attrs[k] != null) n.setAttribute(k, attrs[k]);
    }
    (kids || []).forEach(function (c) { if (c) n.appendChild(typeof c === "string" ? document.createTextNode(c) : c); });
    return n;
  }
  function star(on, sz) {
    return '<svg width="' + sz + '" height="' + sz + '" viewBox="0 0 24 24" aria-hidden="true" style="display:block"><path d="M12 2.2l2.9 5.9 6.5.95-4.7 4.58 1.11 6.47L12 17.06 6.19 20.1 7.3 13.63 2.6 9.05l6.5-.95L12 2.2z" fill="' +
      (on ? "var(--rv-gold,#DAA423)" : "var(--rv-star-off,#cfd2c4)") + '"/></svg>';
  }
  function starsHTML(rating, sz) {
    var o = "";
    for (var i = 1; i <= 5; i++) o += star(i <= Math.round(rating), sz);
    return '<span class="le-rv-stars" role="img" aria-label="' + rating + ' out of 5 stars">' + o + "</span>";
  }

  /* Country flags are drawn client-side — Judge.me's API carries no country, so
     these only appear if a review ever gains one. */
  function paintFlags(scope) {
    scope.querySelectorAll("[data-flag]").forEach(function (s) {
      var code = s.getAttribute("data-flag");
      if (!FLAGS[code] || s.childElementCount) return;
      s.innerHTML = '<svg class="le-rv-flag" width="20" height="14" viewBox="0 0 20 14" aria-hidden="true">' +
        '<defs><clipPath id="fl' + code + '"><rect width="20" height="14" rx="2.5"/></clipPath></defs>' +
        '<g clip-path="url(#fl' + code + ')">' + FLAGS[code] + "</g></svg>";
      var lbl = s.nextElementSibling;
      if (lbl && COUNTRY_NAME[code]) lbl.textContent = COUNTRY_NAME[code] + " · " + lbl.textContent;
    });
  }

  /* ---------- modal: everything comes from the card, no fetch ---------- */
  function openModal(card) {
    var q = function (s) { return card.querySelector(s); };
    var imgEl = q("[data-img]");
    var img = imgEl && imgEl.getAttribute("data-img");
    var name = q("[data-name]") ? q("[data-name]").textContent : "";
    var rating = +card.getAttribute("data-rating") || 5;
    var verified = !!q(".le-rv-verified");
    var meta = q(".le-rv-meta") ? q(".le-rv-meta").innerHTML : "";
    var bought = q("[data-bought]") ? q("[data-bought]").innerHTML : "";
    var body = q("[data-full]") ? q("[data-full]").textContent : "";

    // Close only on the backdrop itself. Stopping propagation on the shell would
    // also stop clicks reaching the document-delegated vote handler — the modal
    // lives outside .le-reviews, so delegation is all it has.
    var scrim = el("div", {
      class: "le-rv-scrim", role: "dialog", "aria-modal": "true",
      onClick: function (e) { if (e.target === scrim) close(); }
    });
    var shell = el("div", { class: "le-rv-modal" + (img ? " has-img" : "") });

    var closeBtn = el("button", {
      class: "le-rv-close", type: "button", "aria-label": "Close", onClick: close,
      html: '<svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>'
    });
    if (img) shell.appendChild(el("div", { class: "le-rv-modal-img" }, [el("img", { src: img, alt: "Photo from " + name + "'s review" })]));

    // Clone the card's footer so the modal carries the same votes and share
    // links. It keeps data-votes, so paintVotes() drives both copies at once and
    // the delegated click handler works without rebinding.
    var foot = q(".le-rv-foot");
    var footClone = null;
    if (foot) {
      footClone = foot.cloneNode(true);
      footClone.classList.add("modal");
    }

    shell.appendChild(closeBtn);
    shell.appendChild(el("div", { class: "le-rv-modal-body" }, [
      el("div", { html: starsHTML(rating, 26) }),
      el("div", {}, [
        el("div", { class: "le-rv-nameline lg", html: '<span class="le-rv-name lg">' + name + "</span>" + (verified ? q(".le-rv-verified").outerHTML : "") }),
        el("div", { class: "le-rv-meta", html: meta })
      ]),
      el("p", { class: "le-rv-body full", text: body }),
      bought ? el("div", { class: "le-rv-bought", html: bought }) : null,
      footClone
    ]));

    var votes = card.querySelector("[data-votes]");
    if (votes) paintVotes(votes.getAttribute("data-votes"));

    scrim.appendChild(shell);
    document.body.appendChild(scrim);
    document.documentElement.classList.add("le-rv-lock");
    document.body.classList.add("le-rv-lock");
    closeBtn.focus();

    function onKey(e) { if (e.key === "Escape") close(); }
    document.addEventListener("keydown", onKey);
    function close() {
      document.documentElement.classList.remove("le-rv-lock");
      document.body.classList.remove("le-rv-lock");
      document.removeEventListener("keydown", onKey);
      scrim.remove();
    }
  }

  /* ---------- votes ----------
     Tallies are keyed by review id and painted into EVERY [data-votes] node
     with that id — a card and its modal clone share one, so they can never drift
     apart. Clicks are delegated from the document for the same reason: the modal
     footer is cloned after load and a cloned node carries no listeners. */
  var WORKER = "";
  var TALLIES = {};
  var VOTED = {};
  try { VOTED = JSON.parse(localStorage.getItem("le-rv-voted") || "{}"); } catch (e) { VOTED = {}; }

  // Brief inline note when the daily edit cap is hit — no alert, no layout shift.
  function flashLimited(id) {
    document.querySelectorAll('[data-votes="' + id + '"] .le-rv-help-lbl').forEach(function (lbl) {
      if (lbl.dataset.flash) return;
      var was = lbl.textContent;
      lbl.dataset.flash = "1";
      lbl.textContent = "Come back tomorrow";
      setTimeout(function () { lbl.textContent = was; delete lbl.dataset.flash; }, 2600);
    });
  }

  function paintVotes(id) {
    var t = TALLIES[id] || { up: 0, down: 0 };
    document.querySelectorAll('[data-votes="' + id + '"]').forEach(function (g) {
      var up = g.querySelector("[data-up]"), down = g.querySelector("[data-down]");
      if (up) up.textContent = t.up || 0;
      if (down) down.textContent = t.down || 0;
      // Never disabled — a vote is a toggle, so it stays clickable to undo or move.
      g.querySelectorAll(".le-rv-vote").forEach(function (b) {
        b.classList.toggle("on", VOTED[id] === b.getAttribute("data-vote"));
      });
    });
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest && e.target.closest(".le-rv-vote");
    if (!btn || btn.disabled || !WORKER) return;
    var group = btn.closest("[data-votes]");
    if (!group) return;
    var id = group.getAttribute("data-votes");
    var dir = btn.getAttribute("data-vote");
    var prev = VOTED[id];
    // Same arrow = take the vote back; other arrow = move it. Mirrors the
    // Worker's transition so the optimistic paint matches what comes back.
    var next = prev === dir ? null : dir;

    var t = TALLIES[id] || { up: 0, down: 0 };
    if (prev) t[prev] = Math.max(0, (t[prev] || 0) - 1);
    if (next) t[next] = (t[next] || 0) + 1;
    TALLIES[id] = t;
    if (next) VOTED[id] = next; else delete VOTED[id];
    try { localStorage.setItem("le-rv-voted", JSON.stringify(VOTED)); } catch (err) {}
    paintVotes(id);

    fetch(WORKER + "/vote", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: id, dir: dir })
    })
      // Parse the body even on 429 (daily cap): it carries the authoritative
      // tally + state, so the optimistic change reverts cleanly when refused.
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, status: r.status, body: b }; }); })
      .then(function (res) {
        var b = res.body;
        if (!b) return;
        // The Worker is authoritative — it knows this IP's prior vote even if
        // localStorage was cleared or a different browser cast it.
        TALLIES[id] = { up: b.up, down: b.down };
        if (b.state) VOTED[id] = b.state; else delete VOTED[id];
        try { localStorage.setItem("le-rv-voted", JSON.stringify(VOTED)); } catch (err) {}
        paintVotes(id);
        if (b.limited) flashLimited(id);
      })
      .catch(function () { /* keep the optimistic count */ });
  });

  function initVotes(root, worker, onLoaded) {
    var groups = root.querySelectorAll("[data-votes]");
    if (!groups.length) return;

    // No Worker configured means no tallies to read or write — hide the control
    // rather than leaving buttons that look clickable and do nothing.
    if (!worker) {
      groups.forEach(function (g) { g.hidden = true; });
      return;
    }
    WORKER = worker;

    function done() {
      groups.forEach(function (g) { paintVotes(g.getAttribute("data-votes")); });
      // Counts arrive after first paint, so a "Most helpful" sort chosen before
      // now was ordering all-zeros. Let the caller re-sort.
      if (onLoaded) onLoaded();
    }

    fetch(worker + "/votes")
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (all) { TALLIES = all || {}; done(); })
      .catch(done); // Worker down: counts stay 0, everything else still works.
  }

  /* ---------- boot ---------- */
  function init(root) {
    if (root.dataset.ready === "1") return;
    root.dataset.ready = "1";

    var section = root.closest(".le-reviews");
    if (!section) return;

    var worker = (root.getAttribute("data-worker") || "").replace(/\/+$/, "");
    var emptyText = root.getAttribute("data-empty-text") || "";
    var panels = {};
    section.querySelectorAll("[data-tab-panel]").forEach(function (p) { panels[p.getAttribute("data-tab-panel")] = p; });

    var els = {
      tabs: section.querySelectorAll("[data-tab]"),
      summary: section.querySelector("[data-summary]"),
      strip: section.querySelector("[data-strip]"),
      filters: section.querySelector("[data-filters]"),
      status: section.querySelector("[data-status]"),
      nav: section.querySelector("[data-nav]"),
      prev: section.querySelector("[data-prev]"),
      next: section.querySelector("[data-next]")
    };

    bindWrite(section);

    var state = { tab: root.getAttribute("data-start-tab") || "product", filter: "all", sort: "recent" };

    function panel() { return panels[state.tab]; }
    function cards() { return panel() ? [].slice.call(panel().querySelectorAll("[data-card]")) : []; }

    paintFlags(section);

    // Modal triggers: the More link and the photo, per the card markup.
    section.querySelectorAll("[data-open]").forEach(function (b) {
      b.addEventListener("click", function () { openModal(b.closest("[data-card]")); });
    });

    // Re-sort once vote counts land — "Most helpful" would otherwise be ordering
    // the zeroes that were on screen before the Worker replied.
    initVotes(section, worker, function () { if (state.sort === "helpful") apply(); });

    function renderSummary() {
      var list = cards();
      if (!list.length) { els.summary.innerHTML = ""; return; }
      var sum = 0, verified = 0;
      list.forEach(function (c) {
        sum += +c.getAttribute("data-rating") || 0;
        if (c.querySelector(".le-rv-verified")) verified++;
      });
      var avg = Math.round((sum / list.length) * 10) / 10;
      els.summary.innerHTML = starsHTML(avg, 22) +
        '<span class="le-rv-avg">' + avg.toFixed(1) + "</span><span>average</span>" +
        (verified ? '<span class="le-rv-dot"></span><b>' + verified + "</b><span>verified reviews</span>" : "");
    }

    function renderStrip() {
      els.strip.innerHTML = "";
      cards().filter(function (c) { return c.getAttribute("data-photo") === "1"; }).forEach(function (c) {
        var src = c.querySelector(".le-rv-thumb img");
        els.strip.appendChild(el("button", {
          class: "le-rv-strip-item", type: "button", "aria-label": "Open this review",
          onClick: function () { openModal(c); }
        }, [el("img", { src: src ? src.src : "", alt: "", loading: "lazy" })]));
      });
    }

    function renderFilters() {
      els.filters.innerHTML = "";
      var list = cards();
      if (list.length < 2) return;

      function countOf(rating) {
        return list.filter(function (c) { return +c.getAttribute("data-rating") === rating; }).length;
      }
      var photoCount = list.filter(function (c) { return c.getAttribute("data-photo") === "1"; }).length;

      // Chips carry their count and go disabled at zero: the rating spread is
      // visible at a glance and no chip leads to an empty list.
      function chip(key, label, withStar, count) {
        var on = state.filter === key;
        var dead = count === 0;
        return el("button", {
          class: "le-rv-chip" + (on ? " on" : ""), type: "button",
          "aria-pressed": on ? "true" : "false",
          disabled: dead ? "" : null,
          title: dead ? "No " + label + "-star reviews yet" : null,
          onClick: function () { state.filter = key; apply(true); renderFilters(); }
        }, [
          withStar ? el("span", { class: "le-rv-stars", html: star(true, 15) }) : null,
          label,
          count != null ? el("span", { class: "le-rv-chip-n", text: "(" + count + ")" }) : null
        ]);
      }

      els.filters.appendChild(chip("all", "All", false, list.length));
      [5, 4, 3, 2, 1].forEach(function (n) { els.filters.appendChild(chip("s" + n, String(n), true, countOf(n))); });
      if (photoCount) els.filters.appendChild(chip("photos", "With photos", false, photoCount));

      // Only offer sorts that can actually change something — a "Photos first"
      // with no photos, or "Most helpful" with no vote data, is a dead control.
      var opts = [["recent", "Most recent"], ["highest", "Highest rated"], ["lowest", "Lowest rated"]];
      if (worker) opts.push(["helpful", "Most helpful"]);
      if (photoCount) opts.push(["photos", "Photos first"]);

      // A sort can vanish when switching tabs (e.g. no photos here).
      if (!opts.some(function (o) { return o[0] === state.sort; })) state.sort = "recent";

      var sel = el("select", { class: "le-rv-sort", "aria-label": "Sort reviews", onChange: function (e) { state.sort = e.target.value; apply(true); } });
      opts.forEach(function (o) {
        var op = el("option", { value: o[0], text: o[1] });
        if (o[0] === state.sort) op.selected = true;
        sel.appendChild(op);
      });
      els.filters.appendChild(el("div", { class: "le-rv-sortwrap" }, [sel]));
    }

    /* Net score, not raw upvotes: 10 up / 9 down is a more divisive review than
       2 up / 0 down, and should not outrank it. */
    function votesOf(c) {
      var up = c.querySelector("[data-up]");
      var down = c.querySelector("[data-down]");
      return (up ? +up.textContent || 0 : 0) - (down ? +down.textContent || 0 : 0);
    }

    /* Reordering leaves scrollLeft where it was, so a filter or sort silently
       lands you in the middle of the new order — the whole point of picking
       "Most helpful" is to see the best first. Reset on user-initiated changes
       only: doing it when vote counts arrive from the Worker would yank a
       reader who had already scrolled. */
    /* Jumps, not glides. The track is `scroll-snap-type: x mandatory`, which
       fights a programmatic smooth scroll and abandons it partway — measured
       stalling at 400px of a 480px reset. Instant is also the honest gesture
       here: the list just reordered underneath, so there is no spatial
       continuity for an animation to convey. */
    function resetScroll() {
      var t = panel();
      if (!t || t.scrollLeft === 0) return;
      t.scrollLeft = 0;
    }

    function apply(userAction) {
      var list = cards();
      var shown = 0;
      list.forEach(function (c) {
        var ok = true;
        if (state.filter[0] === "s") ok = +c.getAttribute("data-rating") === +state.filter.slice(1);
        else if (state.filter === "photos") ok = c.getAttribute("data-photo") === "1";
        c.hidden = !ok;
        if (ok) shown++;
      });

      var vis = list.filter(function (c) { return !c.hidden; });
      vis.sort(function (a, b) {
        var ra = +a.getAttribute("data-rating"), rb = +b.getAttribute("data-rating");
        var ta = +a.getAttribute("data-ts"), tb = +b.getAttribute("data-ts");
        if (state.sort === "highest") return rb - ra || tb - ta;
        if (state.sort === "lowest") return ra - rb || tb - ta;
        if (state.sort === "helpful") return votesOf(b) - votesOf(a) || tb - ta;
        if (state.sort === "photos") return (b.getAttribute("data-photo") - a.getAttribute("data-photo")) || tb - ta;
        return tb - ta;
      });
      vis.forEach(function (c) { panel().appendChild(c); });

      // Chips for empty buckets are disabled, so this is mostly a backstop —
      // but name the bucket anyway rather than saying "no match".
      if (!shown) {
        var msg = emptyText;
        if (state.filter === "photos") msg = "No reviews with photos yet.";
        else if (state.filter[0] === "s") msg = "No " + state.filter.slice(1) + "-star reviews yet.";
        els.status.textContent = msg;
        els.status.hidden = false;
      } else {
        els.status.hidden = true;
      }
      els.nav.hidden = shown <= 1;
      if (userAction) resetScroll();
      updateNav();
    }

    // Arrows only work when the cards overflow the track. Three reviews on
    // desktop all fit, so the arrows would be live buttons that do nothing:
    // grey them out instead. On a phone one card fills the width, so the same
    // three reviews still overflow and the arrows stay usable.
    function updateNav() {
      var t = panel();
      var stuck = !t || t.scrollWidth - t.clientWidth <= 4;
      [els.prev, els.next].forEach(function (b) {
        if (!b) return;
        b.disabled = stuck;
        b.setAttribute("aria-disabled", stuck ? "true" : "false");
      });
    }
    window.addEventListener("resize", updateNav);
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(updateNav);
      for (var pk in panels) if (panels[pk]) ro.observe(panels[pk]);
    }

    els.tabs.forEach(function (t) {
      t.addEventListener("click", function () {
        state.tab = t.getAttribute("data-tab");
        state.filter = "all";
        els.tabs.forEach(function (o) {
          var on = o === t;
          o.classList.toggle("on", on);
          o.setAttribute("aria-selected", on ? "true" : "false");
        });
        for (var k in panels) panels[k].hidden = k !== state.tab;
        renderSummary(); renderStrip(); renderFilters(); apply(true);
      });
    });

    function step() {
      var c = panel() && panel().querySelector("[data-card]:not([hidden])");
      return c ? c.getBoundingClientRect().width + 20 : 340;
    }
    function scrollBy(dir) {
      var t = panel();
      if (!t) return;
      var max = t.scrollWidth - t.clientWidth - 4;
      if (dir > 0 && t.scrollLeft >= max) return t.scrollTo({ left: 0, behavior: "smooth" });
      if (dir < 0 && t.scrollLeft <= 4) return t.scrollTo({ left: max, behavior: "smooth" });
      t.scrollBy({ left: dir * step(), behavior: "smooth" });
    }
    if (els.prev) els.prev.addEventListener("click", function () { scrollBy(-1); });
    if (els.next) els.next.addEventListener("click", function () { scrollBy(1); });

    renderSummary(); renderStrip(); renderFilters(); apply();
  }

  /* ---------- "Write a review" bridge ----------
     Judge.me publishes no JS API for opening its form. The form ships inside their
     "revamp" widget, which their loader only fetches when it finds one of THEIR
     app-block containers (.jdgm-widget[data-entry-point]) — so the merchant must
     add the Judge.me Review Widget app block to the product template. We hide that
     block and forward our button's click to its write control, which keeps our
     styling and their form, with the product already selected.

     An earlier attempt bridged to the LEGACY widget markup instead and could never
     work: the loader ignores it, the revamp path hides it, and it stops publishing
     2026-07-28. Hence the app block.

     If the block is absent or their script has not hydrated, fall back to the
     off-site link rather than doing nothing. */
  /* The revamp widget prefixes its own classes `jm-`, not `jdgm-` — the legacy
     `.jdgm-write-rev-link` does not exist in it. Match their action button, and
     fall back to matching on label if they rename the class. Their modal is
     appended to the page, not inside the widget, so our hiding of the widget does
     not hide the form. */
  function jmWriteEl() {
    var host = document.querySelector(".jdgm-widget[data-entry-point]");
    if (!host) return null;
    return host.querySelector(".jm-action-buttons__button, .jdgm-write-rev-link") ||
      [].slice.call(host.querySelectorAll("button, a")).filter(function (b) {
        return /write a review/i.test(b.textContent || "");
      })[0] || null;
  }

  function bindWrite(section) {
    var btn = section.querySelector("[data-write][data-jm-bridge]");
    if (!btn) return;
    btn.addEventListener("click", function (e) {
      var target = jmWriteEl();
      if (target) { e.preventDefault(); target.click(); return; }
      e.preventDefault();
      // Their bundle hydrates async — wait briefly before giving up on it.
      var waited = 0;
      var t = setInterval(function () {
        var el2 = jmWriteEl();
        waited += 120;
        if (el2) { clearInterval(t); el2.click(); return; }
        if (waited >= 2400) {
          clearInterval(t);
          var href = btn.getAttribute("href");
          if (href && href !== "#") { window.open(href, "_blank", "noopener"); return; }
          console.warn("[le-pdp-reviews] Judge.me form unavailable — is the Judge.me Review Widget app block on this template?");
        }
      }, 120);
    });
  }

  /* Shared with the All Reviews page (assets/le-all-reviews.js), which has its own
     layout (masonry, three scopes, load-more) but must render and behave like the
     product page. Exporting these keeps the card, modal and vote logic in one
     place instead of forked in two. */
  window.LEReviews = {
    el: el,
    star: star,
    starsHTML: starsHTML,
    paintFlags: paintFlags,
    openModal: openModal,
    initVotes: initVotes,
    paintVotes: paintVotes
  };

  function boot(scope) { (scope || document).querySelectorAll("[data-le-reviews]").forEach(init); }
  if (document.readyState !== "loading") boot();
  else document.addEventListener("DOMContentLoaded", function () { boot(); });
  document.addEventListener("shopify:section:load", function (e) { boot(e.target); });
})();
